import { ThreeView } from "../View3dWebCad";
import { CeilingItemOverControls } from '../controls/CeilingItemOverControls';
import { defines } from "../../base";
import { itemLoader } from "./itemLoader";
import { ObjectType } from '../ObjectType';

export class AddCeilingItemLoader extends itemLoader {

    private controller: CeilingItemOverControls;

    constructor(itemId: string, index: string) {
        super(itemId, index);
    }

    // 移動コントローラー作成
    protected createController(object: THREE.Object3D) {
        const camera = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        const element = ThreeView.get().wcRenderer.me.domElement;
        this.controller = new CeilingItemOverControls([object], camera.me, element);
    }

    protected removeController() {
        this.controller.dispose();
        this.controller = undefined;
    }

    protected location(e): boolean {
        const hitObj = ThreeView.get().selectManager.hitObjects(e);

        if (hitObj.length < 1) return;

        return (ObjectType.isCeiling(hitObj[0].object) && ObjectType.isCeiling_(hitObj[0].object));
    }

}
